import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { nanoid } from "@reduxjs/toolkit";
import { getFullUrlPath } from "./HandleFileFunction";
import { getSupplierProductName } from "./HelperProduct";
import moment from "moment";
import { getVatByMstCategoryPrice, isOverDue } from "./HelperFunction";
// private
var pipelineStepsFromQoID = [
    mappingQoItem,
    mappingFromQoID,
    mappingQoMember
];
var pipelineStepsFromQoDoc = [
    mappingQoItem,
    mappingLoadDocFromQoData
];
function mappingQoMember(param) {
    var setPdata = param.setPdata, dataWithReplacements = param.dataWithReplacements;
    if (dataWithReplacements.factMember) {
        var _dataWithReplacements_factMember = dataWithReplacements.factMember, id = _dataWithReplacements_factMember.id, customer_id = _dataWithReplacements_factMember.customer_id;
        var full_member_name = dataWithReplacements.full_member_name, full_member_address_name = dataWithReplacements.full_member_address_name, additional_info = dataWithReplacements.additional_info, member_branch_no = dataWithReplacements.member_branch_no, member_phone_number = dataWithReplacements.member_phone_number;
        setPdata(mappingMemberQo({
            id: id,
            customer_id: customer_id,
            full_member_name: full_member_name,
            full_member_address_name: full_member_address_name,
            additional_info: additional_info,
            member_branch_no: member_branch_no,
            member_phone_number: member_phone_number
        }));
    }
}
function mappingLoadDocFromQoData(param) {
    var setFormdata = param.setFormdata, dataWithReplacements = param.dataWithReplacements;
    setFormdata(function(prev) {
        var doc_number = prev.doc_number, dimMstQoStatus = prev.dimMstQoStatus, dim_mst_qo_status_id = prev.dim_mst_qo_status_id, refer = prev.refer, not_approve_reason = prev.not_approve_reason, updated_approve_at = prev.updated_approve_at, updated_wait_approve_at = prev.updated_wait_approve_at, canceled_at = prev.canceled_at, canceled_by_emp_id = prev.canceled_by_emp_id, is_sort_manual = prev.is_sort_manual, createdNewQoEmp = prev.createdNewQoEmp, dim_mst_payment_type_id = prev.dim_mst_payment_type_id, doc_issue_date = prev.doc_issue_date, doc_expire_date = prev.doc_expire_date, fact_member_id = prev.fact_member_id;
        return _object_spread_props(_object_spread({}, dataWithReplacements), {
            fact_member_id: fact_member_id,
            createdNewQoEmp: createdNewQoEmp,
            doc_number: doc_number,
            dimMstQoStatus: dimMstQoStatus,
            dim_mst_qo_status_id: dim_mst_qo_status_id,
            refer: refer,
            is_sort_manual: is_sort_manual,
            not_approve_reason: not_approve_reason,
            updated_approve_at: updated_approve_at,
            updated_wait_approve_at: updated_wait_approve_at,
            canceled_at: canceled_at,
            canceled_by_emp_id: canceled_by_emp_id,
            dim_mst_payment_type_id: dim_mst_payment_type_id,
            doc_issue_date: doc_issue_date,
            doc_expire_date: doc_expire_date
        });
    });
}
function mappingFromQoID(param) {
    var setFormdisabled = param.setFormdisabled, columnsort = param.columnsort, setColumnsort = param.setColumnsort, setAttachments = param.setAttachments, setTagSelected = param.setTagSelected, dataWithReplacements = param.dataWithReplacements;
    if (dataWithReplacements.factDocFileQo && dataWithReplacements.factDocFileQo.length > 0) {
        var attchments = dataWithReplacements.factDocFileQo.map(function(v, i) {
            var newId = nanoid();
            var type = v.original_file_name.split(".");
            var mappingData = {
                id: newId,
                docId: v.id,
                docFile: v.original_file_name,
                docFileType: type[type.length - 1],
                docFileData: "",
                docUrl: getFullUrlPath(v.file_path, true)
            };
            return mappingData;
        });
        setAttachments(attchments);
    } else {
        setAttachments([]);
    }
    if (dataWithReplacements.factTagQo && dataWithReplacements.factTagQo.length > 0) {
        var mappingData = dataWithReplacements.factTagQo.map(function(v) {
            return v.name;
        });
        setTagSelected(mappingData);
    } else {
        setTagSelected([]);
    }
    if (dataWithReplacements.dimMstQoStatus && dataWithReplacements.dimMstQoStatus.id > 1) {
        setFormdisabled(true);
    }
    dataWithReplacements.dim_mst_new_status_id = "";
    dataWithReplacements.dim_new_item_qo_sorts = [];
    if (dataWithReplacements.factItemQoColSort && dataWithReplacements.factItemQoColSort.length > 0) {
        var mappingCols = dataWithReplacements.factItemQoColSort.map(function(v) {
            return {
                id: v.dimMstItemQoCol.id,
                sortKey: v.dimMstItemQoCol.name
            };
        });
        while(mappingCols.length <= 3){
            mappingCols.push({
                id: "",
                sortKey: ""
            });
        }
        setColumnsort(_object_spread_props(_object_spread({}, columnsort), {
            columnsort: mappingCols
        }));
    }
}
function runMappingPipeline(_param) {
    var pipelineSteps = _param.pipelineSteps, context = _object_without_properties(_param, [
        "pipelineSteps"
    ]);
    pipelineSteps.forEach(function(fn) {
        fn(context);
    });
}
// public
export function mappingQoItem(param) {
    var setProductRow = param.setProductRow, dataWithReplacements = param.dataWithReplacements;
    if (dataWithReplacements.factNewQoItem && dataWithReplacements.factNewQoItem.length > 0) {
        var productItems = dataWithReplacements.factNewQoItem.map(function(v) {
            var _dimProductPrice_dimProduct, _dimProductPrice_dimProduct1, _dimProductPrice_dimProduct2, _dimProductPrice_dimProduct3;
            var dim_product_price_id = v.dim_product_price_id, quantity = v.quantity, unit_price = v.unit_price, unit_id = v.unit_id, ratio_unit = v.ratio_unit, container = v.container, dim_mst_discount_type_id = v.dim_mst_discount_type_id, remark = v.remark, discount_value = v.discount_value, discount_price = v.discount_price, dimWarehouse = v.dimWarehouse, dimProductPrice = v.dimProductPrice, dimMasterUnit = v.dimMasterUnit, dimMstVat = v.dimMstVat, dimNewPoSplitItem = v.dimNewPoSplitItem;
            // console.log(discount_price);
            var mappingData = {
                rowID: nanoid(),
                productID: dim_product_price_id,
                productCode: (_dimProductPrice_dimProduct = dimProductPrice.dimProduct) === null || _dimProductPrice_dimProduct === void 0 ? void 0 : _dimProductPrice_dimProduct.sku,
                productName: (_dimProductPrice_dimProduct1 = dimProductPrice.dimProduct) === null || _dimProductPrice_dimProduct1 === void 0 ? void 0 : _dimProductPrice_dimProduct1.name_th,
                productBarcode: dimProductPrice.barcode,
                productUnitID: unit_id,
                productRatioUnit: ratio_unit,
                productContainer: container,
                supplierCode: (_dimProductPrice_dimProduct2 = dimProductPrice.dimProduct) === null || _dimProductPrice_dimProduct2 === void 0 ? void 0 : _dimProductPrice_dimProduct2.supplier_code,
                supplierName: getSupplierProductName((_dimProductPrice_dimProduct3 = dimProductPrice.dimProduct) === null || _dimProductPrice_dimProduct3 === void 0 ? void 0 : _dimProductPrice_dimProduct3.supplier_names),
                warehouseID: dimWarehouse.id,
                warehouseName: dimWarehouse.name,
                productUnit: dimMasterUnit ? dimMasterUnit.name : "-",
                productQty: quantity,
                productOrdered: dimNewPoSplitItem ? dimNewPoSplitItem.total_received_quantity : 0,
                ums: "",
                productStock: "",
                productPrice: unit_price,
                discountType: dim_mst_discount_type_id,
                discount: discount_price,
                discountPercent: discount_value,
                tax: "",
                price_before_tax: 0,
                dim_mst_vat_id: dimMstVat.id,
                vat: dimMstVat.value,
                note: remark,
                price_after_tax: 0,
                not_approve_reason: "",
                is_checked: false,
                edit: false
            };
            return mappingData;
        });
        dataWithReplacements.products = productItems;
        setProductRow(productItems);
    }
}
export function mappingMemberQo(param) {
    var id = param.id, customer_id = param.customer_id, full_member_name = param.full_member_name, full_member_address_name = param.full_member_address_name, additional_info = param.additional_info, member_branch_no = param.member_branch_no, member_phone_number = param.member_phone_number;
    return {
        customerID: id,
        customerCode: customer_id,
        customerName: full_member_name,
        customerNameShort: "-",
        branchCode: member_branch_no,
        branchName: additional_info,
        address: full_member_address_name,
        phoneNumber: member_phone_number
    };
}
export function mappingOptionNewItemQoCol(options) {
    return options.map(function(item) {
        var sortKey = "";
        switch(item.name_th){
            case "รหัสสินค้า":
                sortKey = "productCode";
                break;
            case "รายการ":
                sortKey = "productName";
                break;
            case "บาร์โค้ด":
                sortKey = "productBarcode";
                break;
            case "คลังจัดส่ง":
                sortKey = "warehouseName";
                break;
            case "หน่วย":
                sortKey = "productUnit";
                break;
            case "จำนวน":
                sortKey = "productQty";
                break;
            case "ราคา/หน่วย":
                sortKey = "productPrice";
                break;
            case "ประเภทส่วนลด":
                sortKey = "discountType";
                break;
            case "ส่วนลด/หน่วย":
                sortKey = "discount";
                break;
            case "ภาษี":
                sortKey = "vat";
                break;
            case "มูลค่าก่อนภาษี":
                sortKey = "valueBeforeVat";
                break;
            case "มูลค่ารวมภาษี":
                sortKey = "valueIncludingVat";
                break;
            default:
                break;
        }
        return {
            label: item.name_th,
            value: item.id,
            sortKey: sortKey
        };
    });
}
export function mappingQo(param) {
    var qoData = param.qoData, setPdata = param.setPdata, setProductRow = param.setProductRow, setFormdisabled = param.setFormdisabled, columnsort = param.columnsort, setColumnsort = param.setColumnsort, setAttachments = param.setAttachments, setTagSelected = param.setTagSelected;
    var dataWithReplacements = Object.entries(qoData).reduce(function(acc, param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
        acc[key] = value === null ? "" : value;
        return acc;
    }, {});
    runMappingPipeline({
        pipelineSteps: pipelineStepsFromQoID,
        setProductRow: setProductRow,
        setPdata: setPdata,
        setFormdisabled: setFormdisabled,
        columnsort: columnsort,
        setColumnsort: setColumnsort,
        setAttachments: setAttachments,
        setTagSelected: setTagSelected,
        dataWithReplacements: dataWithReplacements
    });
    return dataWithReplacements;
}
export var mapProductToRequestItem = function(product) {
    return product.map(function(v) {
        return {
            dim_product_price_id: v.productID,
            dim_warehouse_id: v.warehouseID,
            quantity: v.productQty,
            unit_price: v.productPrice,
            unit_id: v.productUnitID,
            ratio_unit: v.productRatioUnit,
            container: v.productContainer,
            dim_mst_discount_type_id: v.discountType,
            discount_value: v.discountType === 1 ? v.discountPercent : v.discount,
            discount_price: v.discount,
            dim_mst_vat_id: v.dim_mst_vat_id,
            remark: v.note
        };
    });
};
export var jsonKeys = [
    "update_doc_ids",
    "tag_qoes",
    "fact_new_qo_items",
    "doc_files"
];
export var allowedFields = [
    "dim_mst_qo_status_id",
    "dim_mst_payment_type_id",
    "dim_mst_price_category_id",
    "doc_issue_date",
    "doc_expire_date",
    "fact_member_id",
    "dim_warehouse_id",
    "dim_branch_id",
    "refer",
    "dim_mst_discount_type_id",
    "discount_value",
    "discount_price",
    "remark",
    "is_sort_manual",
    "not_approve_reason",
    "fact_item_qo_col_sorts"
].concat(_to_consumable_array(jsonKeys));
export function getActionQoDisplay(param) {
    var formdisabled = param.formdisabled, dimMstNewStatus = param.dimMstNewStatus;
    var status1 = !formdisabled && (!dimMstNewStatus || dimMstNewStatus && dimMstNewStatus.id < 3 || dimMstNewStatus && dimMstNewStatus.id === 5);
    var status2 = !formdisabled && (!dimMstNewStatus || dimMstNewStatus && dimMstNewStatus.id !== 5);
    var status2_1 = !(dimMstNewStatus && dimMstNewStatus.id > 1);
    var status4 = !!(dimMstNewStatus && dimMstNewStatus.id > 1 && dimMstNewStatus.id < 3);
    var status5 = !!(dimMstNewStatus && dimMstNewStatus.id > 2);
    var statusDropdown4 = !dimMstNewStatus || dimMstNewStatus && dimMstNewStatus.id < 4;
    var statusDropdown4_1 = !(dimMstNewStatus && dimMstNewStatus.id > 1);
    var statusDropdown5 = !!(dimMstNewStatus && dimMstNewStatus.id > 1);
    var statusPrint = !!(dimMstNewStatus && [
        2,
        3,
        4
    ].includes(dimMstNewStatus.id));
    var actionDisplay = {
        status1: status1,
        status2: status2,
        status2_1: status2_1,
        status4: status4,
        status5: status5,
        statusDropdown4: statusDropdown4,
        statusDropdown4_1: statusDropdown4_1,
        statusDropdown5: statusDropdown5,
        statusPrint: statusPrint
    };
    return actionDisplay;
}
export function isDisabledEditQo(param) {
    var dimMstNewStatus = param.dimMstNewStatus;
    var disabledList = [
        4,
        5
    ];
    if (dimMstNewStatus && disabledList.includes(parseInt(dimMstNewStatus.id))) {
        return true;
    }
    return false;
}
export function getDateQoByStatus(param) {
    var values = param.values, label = param.label;
    if (label === "สร้างใบเสนอราคา" && values.created_at) {
        return moment(values.created_at, "YYYY-MM-DD").add(7, "hours").format("DD/MM/YYYY");
    } else if (label === "ขออนุมัติใบเสนอราคา" && values.updated_wait_approve_at) {
        return moment(values.updated_wait_approve_at, "YYYY-MM-DD").add(7, "hours").format("DD/MM/YYYY");
    } else if (label === "อนุมัติแล้ว" && values.updated_approve_at) {
        return moment(values.updated_approve_at, "YYYY-MM-DD").add(7, "hours").format("DD/MM/YYYY");
    } else if (label === "หมดอายุ" && values.doc_expire_date && isOverDue(values.doc_expire_date)) {
        return moment(values.doc_expire_date, "YYYY-MM-DD").format("DD/MM/YYYY");
    }
    return "-";
}
export function loadDocDataProcess(param) {
    var docSelected = param.docSelected, setProductRow = param.setProductRow, setFormdata = param.setFormdata;
    if (docSelected) {
        var dataWithReplacements = Object.entries(docSelected).reduce(function(acc, param) {
            var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
            acc[key] = value === null ? "" : value;
            return acc;
        }, {});
        runMappingPipeline({
            pipelineSteps: pipelineStepsFromQoDoc,
            setProductRow: setProductRow,
            setFormdata: setFormdata,
            dataWithReplacements: dataWithReplacements
        });
    }
}
export function handleRowSelectOverride(param) {
    var ids = param.ids, setProductRow = param.setProductRow, filteredItems = param.filteredItems, optionsWarehouse = param.optionsWarehouse, values = param.values;
    var selectedIDs = new Set(ids);
    var selectedRows = filteredItems.filter(function(row) {
        return selectedIDs.has(row.productID);
    });
    if (selectedRows.length > 0) {
        setProductRow(function(productRow) {
            var _selectedRows__dimProduct, _selectedRows__dimProduct1;
            var warehouseID = values.dim_warehouse_id;
            var warehouse = optionsWarehouse.find(function(item) {
                return values.dim_warehouse_id === item.value;
            });
            var warehouseName = warehouse ? warehouse.label : "";
            var vatByMstCatPrice = getVatByMstCategoryPrice(values.dim_mst_price_category_id, selectedRows[selectedRows.length - 1].dim_mst_vat_id, selectedRows[selectedRows.length - 1].vat);
            var lastSelectedRow = _object_spread_props(_object_spread({}, selectedRows[selectedRows.length - 1]), {
                rowID: nanoid(),
                supplierCode: (_selectedRows__dimProduct = selectedRows[selectedRows.length - 1].dimProduct) === null || _selectedRows__dimProduct === void 0 ? void 0 : _selectedRows__dimProduct.supplier_code,
                supplierName: getSupplierProductName((_selectedRows__dimProduct1 = selectedRows[selectedRows.length - 1].dimProduct) === null || _selectedRows__dimProduct1 === void 0 ? void 0 : _selectedRows__dimProduct1.supplier_names),
                warehouseID: warehouseID,
                warehouseName: warehouseName,
                dim_mst_vat_id: vatByMstCatPrice.dim_mst_vat_id,
                vat: vatByMstCatPrice.vat,
                productPrice: selectedRows[selectedRows.length - 1].sellPrice
            });
            var existingRowIndex = productRow.findIndex(function(row) {
                return !row.productID;
            });
            if (existingRowIndex !== -1) {
                var updatedRows = _to_consumable_array(productRow);
                updatedRows[existingRowIndex] = lastSelectedRow;
                return updatedRows;
            } else {
                return _to_consumable_array(productRow).concat([
                    lastSelectedRow
                ]);
            }
        });
    }
}
export var handleOnSelectProductRowOverrideQO = function(param) {
    var item = param.item, rowID = param.rowID, values = param.values, optionsWarehouse = param.optionsWarehouse, optionsMstVat = param.optionsMstVat, setProductRow = param.setProductRow;
    setProductRow(function(prev) {
        return prev.map(function(el) {
            if (el.rowID === rowID) {
                var _item_dimProduct, _item_dimProduct1;
                var warehouseID = null;
                var warehouseName = null;
                warehouseID = values.dim_warehouse_id;
                var warehouse = optionsWarehouse.find(function(item) {
                    return values.dim_warehouse_id === item.value;
                });
                warehouseName = warehouse ? warehouse.label : "";
                var dim_mst_vat_id = null;
                var vat = 0;
                optionsMstVat.map(function(v) {
                    if (item.dimProduct && item.dimProduct.vat === "ไม่มี VAT" && v.value === 1) {
                        dim_mst_vat_id = v.value;
                        vat = v.vat;
                    }
                    if (item.dimProduct && item.dimProduct.vat === "VAT 0%" && v.value === 2) {
                        dim_mst_vat_id = v.value;
                        vat = v.vat;
                    }
                    if (item.dimProduct && item.dimProduct.vat === "VAT 7%" && v.value === 3) {
                        dim_mst_vat_id = v.value;
                        vat = v.vat;
                    }
                });
                var vatByMstCatPrice = getVatByMstCategoryPrice(values.dim_mst_price_category_id, dim_mst_vat_id, vat);
                return _object_spread_props(_object_spread({}, el), {
                    productCode: item.dimProduct && item.dimProduct.sku ? item.dimProduct.sku : "-",
                    productID: item.id,
                    productName: item.dimProduct && item.dimProduct.name_th ? item.dimProduct.name_th : "-",
                    supplierCode: (_item_dimProduct = item.dimProduct) === null || _item_dimProduct === void 0 ? void 0 : _item_dimProduct.supplier_code,
                    supplierName: getSupplierProductName((_item_dimProduct1 = item.dimProduct) === null || _item_dimProduct1 === void 0 ? void 0 : _item_dimProduct1.supplier_names),
                    productRatioUnit: item.ratio_unit,
                    productContainer: item.container,
                    productBarcode: item.barcode,
                    sellPrice: item.price_1,
                    productPrice: item.price_1,
                    productUnit: item.dimMasterUnit && item.dimMasterUnit.name ? item.dimMasterUnit.name : "-",
                    productUnitID: item.dimMasterUnit && item.dimMasterUnit.id ? item.dimMasterUnit.id : "-",
                    productOrdered: item.productOrdered,
                    ums: item.ums,
                    productStock: item.productStock,
                    warehouseID: warehouseID,
                    warehouseName: warehouseName,
                    discountType: 1,
                    discountPercent: 0,
                    discount: 0,
                    productQty: 1,
                    edit: false,
                    dim_mst_vat_id: vatByMstCatPrice.dim_mst_vat_id,
                    vat: vatByMstCatPrice.vat
                });
            }
            return el;
        });
    });
};
